var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.2 43.5l32.5-40.7c2.5-3.2 7.2-3.7 10.4-1.2 3.2 2.5 3.7 7.2 1.2 10.4 0 0-34.7 43.4-34.6 43.3 -2.3 3.1-6 4.8-9.9 4.7 -3.9-0.1-7.5-2.1-9.5-5.1l-10.8-15.2c-2.4-3.3-1.6-7.9 1.7-10.3 3.3-2.4 7.9-1.6 10.3 1.7l8.8 12.4Z"}));
}

Check.defaultProps = {"width":"68","height":"60","viewBox":"0 0 68 60","strokeLinejoin":"round"};

module.exports = Check;

Check.default = Check;
